import { render } from "./trainingIcon.svg?vue&type=template&id=2160038d"
const script = {}
script.render = render

export default script